import { get, post } from '@/utils/xhr'

class Reward {
  SubmitReferralCode = (referralCode?: string) => {
    return post(`/points/submit-referral/`, { referralCode })
  }
  MyPoints = async () => {
    try {
      const mypoint = await get(`/points/get-my-points/`)
      return mypoint
    } catch (error) {
      console.error('Error fetching my points:', error)
      throw error
    }
  }
  Leaderboard = async () => {
    try {
      const leaderboard = await get(`/points/leaderboard/`)
      return leaderboard
    } catch (error) {
      console.error('Error fetching leaderboard:', error)
      throw error
    }
  }
  ClaimPointsReward = () => post(`/points/claim-reward`)
}
export const rewardService = new Reward()
